import { put, call } from 'redux-saga/effects';
import { apiPeerCategoriesGet, apiPeerCategoriesInstrumentsGet } from '../api/peerCategory';
import { PEER_CATEGORIES_GET, PEER_CATEGORIES_INSTRUMENTS_GET } from '../actions/types';
import { createQadraSaga } from './shared';

function* peerCategoriesGet() {
  const { peerCategories } = yield call(apiPeerCategoriesGet);
  yield put({
    type: PEER_CATEGORIES_GET._SUCCESS,
    payload: { peerCategories },
  });
}

const watchPeerCategoriesGet = createQadraSaga(peerCategoriesGet, {
  action: PEER_CATEGORIES_GET._REQUEST,
});

export function* peerCategoriesInstrumentsGet({ payload: { peerCategoryId } }) {
  const { instruments } = yield call(apiPeerCategoriesInstrumentsGet, peerCategoryId);

  yield put({
    type: PEER_CATEGORIES_INSTRUMENTS_GET._SUCCESS,
    payload: { peerCategoryId, instruments },
  });
}

const watchPeerCategoriesInstrumentsGet = createQadraSaga(peerCategoriesInstrumentsGet, {
  action: PEER_CATEGORIES_INSTRUMENTS_GET._REQUEST,
});

export default [watchPeerCategoriesGet, watchPeerCategoriesInstrumentsGet];
